// 카카오 SDK 초기화
export const initKakao = () => {
  if (window.Kakao && !window.Kakao.isInitialized()) {
    const kakaoKey = process.env.REACT_APP_KAKAO_JS_KEY;
    if (kakaoKey) {
      window.Kakao.init(kakaoKey);
    } else {
    }
  }
};

